<template>
  <v-container class="modern-sponsors-container" fluid ma-0 pa-0>
    <!-- Modern Header -->
    <div class="modern-sponsors-header">
      <div class="header-background">
        <div class="header-circle header-circle-1"></div>
        <div class="header-circle header-circle-2"></div>
        <div class="header-circle header-circle-3"></div>
      </div>
      <div class="header-content-wrapper">
        <div class="header-icon-wrapper">
          <v-icon size="56" color="white">mdi-handshake</v-icon>
        </div>
        <div class="header-text-content">
          <h1 class="modern-sponsors-title">Our Sponsors</h1>
          <p class="modern-sponsors-subtitle">
            <v-icon small color="white" class="mr-1">mdi-heart</v-icon>
            Thank You for Your Generous Support
          </p>
        </div>
      </div>
    </div>

    <v-row class="ma-0 px-4 py-6" justify="center">
      <v-col cols="12" md="11" lg="10">
        <!-- Stats Cards -->
        <v-row class="mb-6">
          <v-col cols="12" sm="4" class="pa-2">
            <v-card class="modern-stats-card platinum-stats-card" elevation="0">
              <div class="stats-card-content">
                <div class="stats-icon-wrapper platinum-icon">
                  <v-icon color="white" size="32">mdi-crown</v-icon>
                </div>
                <div class="stats-info">
                  <div class="stats-label">{{ filteredGallery.length }}</div>
                  <div class="stats-sublabel">Platinum Sponsors</div>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4" class="pa-2">
            <v-card class="modern-stats-card diamond-stats-card" elevation="0">
              <div class="stats-card-content">
                <div class="stats-icon-wrapper diamond-icon">
                  <v-icon color="white" size="32">mdi-diamond-stone</v-icon>
                </div>
                <div class="stats-info">
                  <div class="stats-label">{{ diamondGallery.length }}</div>
                  <div class="stats-sublabel">Diamond Sponsors</div>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4" class="pa-2">
            <v-card class="modern-stats-card gold-stats-card" elevation="0">
              <div class="stats-card-content">
                <div class="stats-icon-wrapper gold-icon">
                  <v-icon color="white" size="32">mdi-trophy</v-icon>
                </div>
                <div class="stats-info">
                  <div class="stats-label">{{ goldGallery.length }}</div>
                  <div class="stats-sublabel">Gold Sponsors</div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Platinum Sponsors Section -->
        <div v-if="filteredGallery.length > 0" class="modern-sponsor-section mb-6">
          <div class="sponsor-section-header">
            <div class="section-icon-badge platinum-badge">
              <v-icon color="white" size="24">mdi-crown</v-icon>
            </div>
            <h2 class="sponsor-section-title">Platinum Sponsors</h2>
          </div>

          <v-row class="sponsor-grid">
            <v-col
              v-for="item in filteredGallery"
              :key="item.order"
              cols="12"
              sm="6"
              md="4"
              lg="3"
              class="pa-2"
            >
              <v-card
                class="modern-sponsor-card platinum-card"
                elevation="0"
                @click.stop="navigateTo(item.url)"
              >
                <div class="sponsor-card-inner">
                  <div class="sponsor-image-wrapper">
                    <v-img
                      v-if="item.type === 'Photo'"
                      class="sponsor-image"
                      :src="item.photo"
                      contain
                    ></v-img>
                  </div>
                  <div class="sponsor-overlay">
                    <v-icon color="white" size="32">mdi-open-in-new</v-icon>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>

        <!-- Diamond Sponsors Section -->
        <div v-if="diamondGallery.length > 0" class="modern-sponsor-section mb-6">
          <div class="sponsor-section-header">
            <div class="section-icon-badge diamond-badge">
              <v-icon color="white" size="24">mdi-diamond-stone</v-icon>
            </div>
            <h2 class="sponsor-section-title">Diamond Sponsors</h2>
          </div>

          <v-row class="sponsor-grid">
            <v-col
              v-for="item in diamondGallery"
              :key="item.order"
              cols="12"
              sm="6"
              md="4"
              lg="3"
              class="pa-2"
            >
              <v-card
                class="modern-sponsor-card diamond-card"
                elevation="0"
                @click.stop="navigateTo(item.url)"
              >
                <div class="sponsor-card-inner">
                  <div class="sponsor-image-wrapper">
                    <v-img
                      v-if="item.type === 'Photo'"
                      class="sponsor-image"
                      :src="item.photo"
                      contain
                    ></v-img>
                  </div>
                  <div class="sponsor-overlay">
                    <v-icon color="white" size="32">mdi-open-in-new</v-icon>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>

        <!-- Gold Sponsors Section -->
        <div v-if="goldGallery.length > 0" class="modern-sponsor-section mb-6">
          <div class="sponsor-section-header">
            <div class="section-icon-badge gold-badge">
              <v-icon color="white" size="24">mdi-trophy</v-icon>
            </div>
            <h2 class="sponsor-section-title">Gold Sponsors</h2>
          </div>

          <v-row class="sponsor-grid">
            <v-col
              v-for="item in goldGallery"
              :key="item.order"
              cols="12"
              sm="6"
              md="4"
              lg="3"
              class="pa-2"
            >
              <v-card
                class="modern-sponsor-card gold-card"
                elevation="0"
                @click.stop="navigateTo(item.url)"
              >
                <div class="sponsor-card-inner">
                  <div class="sponsor-image-wrapper">
                    <v-img
                      v-if="item.type === 'Photo'"
                      class="sponsor-image"
                      :src="item.photo"
                      contain
                    ></v-img>
                  </div>
                  <div class="sponsor-overlay">
                    <v-icon color="white" size="32">mdi-open-in-new</v-icon>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>

    <extended-footer></extended-footer>
  </v-container>
</template>
          
<script>
import ReportServices from '@/services/ReportServices'
import ExtendedFooter from '@/components/Footer'
    
export default {
    computed: {
        filteredGallery() {
            return this.gallery.filter(item => item.category === 'Platinum');
        },
        goldGallery() {
            return this.gallery.filter(item => item.category === 'Gold');
        },
        diamondGallery() {
            return this.gallery.filter(item => item.category === 'Diamond');
        }
    },
    data : () => ({
        gallery: []
    }),
    components: {
        ExtendedFooter
    },
    methods: {
    navigateTo (item) {
            window.open(item, '_blank')
        }
    },
    async mounted () {
        this.gallery = (await ReportServices.getSponsors()).data
        this.gallery.reverse()
    }
}
</script>

<style scoped lang="scss">
* {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}

/* Container */
.modern-sponsors-container {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%) !important;
  min-height: 100vh !important;
}

/* Modern Header */
.modern-sponsors-header {
  position: relative !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  padding: 50px 24px !important;
  overflow: hidden !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15) !important;
}

.header-background {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  overflow: hidden !important;
}

.header-circle {
  position: absolute !important;
  border-radius: 50% !important;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, transparent 70%) !important;
}

.header-circle-1 {
  width: 400px !important;
  height: 400px !important;
  top: -200px !important;
  right: -100px !important;
}

.header-circle-2 {
  width: 300px !important;
  height: 300px !important;
  bottom: -150px !important;
  left: -50px !important;
}

.header-circle-3 {
  width: 200px !important;
  height: 200px !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  opacity: 0.5 !important;
}

.header-content-wrapper {
  position: relative !important;
  z-index: 2 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 24px !important;
  flex-wrap: wrap !important;
}

.header-icon-wrapper {
  width: 80px !important;
  height: 80px !important;
  border-radius: 20px !important;
  background: rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(20px) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.15),
    inset 0 2px 4px rgba(255, 255, 255, 0.3) !important;
}

.header-text-content {
  text-align: center !important;
}

.modern-sponsors-title {
  font-size: 42px !important;
  font-weight: 800 !important;
  color: white !important;
  margin: 0 !important;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
  letter-spacing: -0.5px !important;
}

.modern-sponsors-subtitle {
  font-size: 16px !important;
  color: rgba(255, 255, 255, 0.95) !important;
  margin: 8px 0 0 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 4px !important;
}

/* Stats Cards */
.modern-stats-card {
  border-radius: 16px !important;
  background: linear-gradient(145deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(248, 250, 252, 0.9) 100%) !important;
  backdrop-filter: blur(30px) !important;
  border: 2px solid rgba(255, 255, 255, 0.8) !important;
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.1),
    0 4px 12px rgba(0, 0, 0, 0.06),
    inset 0 2px 4px rgba(255, 255, 255, 1) !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
  overflow: hidden !important;
}

.modern-stats-card::before {
  content: '' !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  height: 4px !important;
  background-size: 200% 100% !important;
  animation: gradientFlow 3s ease infinite !important;
}

.platinum-stats-card::before {
  background: linear-gradient(90deg, #E5E4E2 0%, #BCC6CC 50%, #F0F0F0 100%) !important;
}

.diamond-stats-card::before {
  background: linear-gradient(90deg, #B9F2FF 0%, #00CED1 50%, #E0FFFF 100%) !important;
}

.gold-stats-card::before {
  background: linear-gradient(90deg, #FFD700 0%, #FFC700 50%, #FFE55C 100%) !important;
}

.modern-stats-card:hover {
  transform: translateY(-8px) scale(1.03) !important;
  box-shadow:
    0 16px 40px rgba(0, 0, 0, 0.15),
    0 8px 16px rgba(0, 0, 0, 0.1),
    inset 0 2px 4px rgba(255, 255, 255, 1) !important;
}

.stats-card-content {
  padding: 20px !important;
  display: flex !important;
  align-items: center !important;
  gap: 16px !important;
}

.stats-icon-wrapper {
  width: 56px !important;
  height: 56px !important;
  border-radius: 14px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.15),
    inset 0 1px 2px rgba(255, 255, 255, 0.3) !important;
  position: relative !important;
  overflow: hidden !important;
  flex-shrink: 0 !important;
}

.stats-icon-wrapper::before {
  content: '' !important;
  position: absolute !important;
  top: -50% !important;
  left: -50% !important;
  width: 200% !important;
  height: 200% !important;
  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.3), transparent) !important;
  transform: rotate(45deg) !important;
  animation: shimmer 3s infinite !important;
}

.platinum-icon {
  background: linear-gradient(135deg, #E5E4E2 0%, #BCC6CC 100%) !important;
}

.diamond-icon {
  background: linear-gradient(135deg, #B9F2FF 0%, #00CED1 100%) !important;
}

.gold-icon {
  background: linear-gradient(135deg, #FFD700 0%, #FFC700 100%) !important;
}

.stats-info {
  flex: 1 !important;
}

.stats-label {
  font-size: 28px !important;
  font-weight: 700 !important;
  color: #1f2937 !important;
  line-height: 1.2 !important;
  margin-bottom: 4px !important;
}

.stats-sublabel {
  font-size: 12px !important;
  font-weight: 600 !important;
  color: #64748b !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
}

/* Sponsor Section */
.modern-sponsor-section {
  margin-bottom: 48px !important;
}

.sponsor-section-header {
  display: flex !important;
  align-items: center !important;
  gap: 16px !important;
  margin-bottom: 24px !important;
  padding: 0 8px !important;
}

.section-icon-badge {
  width: 48px !important;
  height: 48px !important;
  border-radius: 12px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.2),
    inset 0 1px 2px rgba(255, 255, 255, 0.3) !important;
}

.platinum-badge {
  background: linear-gradient(135deg, #E5E4E2 0%, #BCC6CC 100%) !important;
}

.diamond-badge {
  background: linear-gradient(135deg, #B9F2FF 0%, #00CED1 100%) !important;
}

.gold-badge {
  background: linear-gradient(135deg, #FFD700 0%, #FFC700 100%) !important;
}

.sponsor-section-title {
  font-size: 28px !important;
  font-weight: 700 !important;
  color: #1f2937 !important;
  margin: 0 !important;
}

/* Sponsor Cards */
.modern-sponsor-card {
  border-radius: 16px !important;
  background: linear-gradient(145deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(248, 250, 252, 0.9) 100%) !important;
  backdrop-filter: blur(30px) !important;
  border: 2px solid rgba(255, 255, 255, 0.8) !important;
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.1),
    0 4px 12px rgba(0, 0, 0, 0.06),
    inset 0 2px 4px rgba(255, 255, 255, 1) !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
  overflow: hidden !important;
  cursor: pointer !important;
}

.modern-sponsor-card::before {
  content: '' !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  height: 4px !important;
  background-size: 200% 100% !important;
  animation: gradientFlow 3s ease infinite !important;
}

.platinum-card::before {
  background: linear-gradient(90deg, #E5E4E2 0%, #BCC6CC 50%, #F0F0F0 100%) !important;
}

.diamond-card::before {
  background: linear-gradient(90deg, #B9F2FF 0%, #00CED1 50%, #E0FFFF 100%) !important;
}

.gold-card::before {
  background: linear-gradient(90deg, #FFD700 0%, #FFC700 50%, #FFE55C 100%) !important;
}

.modern-sponsor-card:hover {
  transform: translateY(-12px) scale(1.05) !important;
  box-shadow:
    0 20px 48px rgba(0, 0, 0, 0.2),
    0 8px 16px rgba(0, 0, 0, 0.12),
    inset 0 2px 4px rgba(255, 255, 255, 1) !important;
}

.modern-sponsor-card:hover .sponsor-overlay {
  opacity: 1 !important;
}

.sponsor-card-inner {
  position: relative !important;
  width: 100% !important;
  height: 220px !important;
  overflow: hidden !important;
}

.sponsor-image-wrapper {
  width: 100% !important;
  height: 100% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 20px !important;
  background: white !important;
  border-radius: 14px !important;
}

.sponsor-image {
  width: 100% !important;
  height: 100% !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.modern-sponsor-card:hover .sponsor-image {
  transform: scale(1.1) !important;
}

.sponsor-overlay {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.9) 0%, rgba(118, 75, 162, 0.9) 100%) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  opacity: 0 !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
  border-radius: 14px !important;
}

/* Animations */
@keyframes gradientFlow {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%) translateY(-100%) rotate(45deg);
  }
  100% {
    transform: translateX(100%) translateY(100%) rotate(45deg);
  }
}

/* Responsive Design */
@media (max-width: 960px) {
  .modern-sponsors-title {
    font-size: 36px !important;
  }

  .modern-sponsors-subtitle {
    font-size: 14px !important;
  }

  .sponsor-section-title {
    font-size: 24px !important;
  }

  .stats-label {
    font-size: 24px !important;
  }
}

@media (max-width: 600px) {
  .modern-sponsors-header {
    padding: 40px 16px !important;
  }

  .header-icon-wrapper {
    width: 64px !important;
    height: 64px !important;
  }

  .modern-sponsors-title {
    font-size: 28px !important;
  }

  .modern-sponsors-subtitle {
    font-size: 13px !important;
  }

  .stats-card-content {
    padding: 16px !important;
  }

  .stats-icon-wrapper {
    width: 48px !important;
    height: 48px !important;
  }

  .stats-label {
    font-size: 20px !important;
  }

  .stats-sublabel {
    font-size: 11px !important;
  }

  .sponsor-section-title {
    font-size: 20px !important;
  }

  .section-icon-badge {
    width: 40px !important;
    height: 40px !important;
  }

  .sponsor-card-inner {
    height: 180px !important;
  }

  .sponsor-image-wrapper {
    padding: 16px !important;
  }
}
</style>
          